import { FadeUp, MaskLines, Em, Eyebrow } from "@/components/site/Motion";

const STATS = [
  { n: "60", u: "min", t: "until someone on our team has read your brief and called you back.", cls: "lg:col-span-5 lg:row-span-2", big: true },
  { n: "5", u: "hrs", t: "until a first shortlist of screened, interested, available people lands.", cls: "lg:col-span-4 lg:mt-24" },
  { n: "2", u: "wings", t: "PITSUS in the USA, PITSIND in India. When one clocks off, the other is on.", cls: "lg:col-span-3" },
  { n: "4", u: "flags", t: "We hire for teams across the US, the UK, EMEA and APAC.", cls: "lg:col-span-4 lg:col-start-7" },
];

export const Numbers = () => (
  <section className="grain grain-dark relative overflow-hidden bg-[#2234F5] px-5 py-24 text-white sm:px-8 lg:py-36" data-testid="numbers-section">
    <div className="relative mx-auto max-w-[1400px]">
      <Eyebrow className="text-[#D4FF3D]">the scoreboard</Eyebrow>
      <MaskLines as="h2" lines={["the only numbers", <>we'll put <Em>our name on.</Em></>]}
        className="font-display mt-6 max-w-4xl text-4xl font-bold leading-[0.95] tracking-[-0.03em] sm:text-6xl" />
      <p className="mt-6 max-w-lg text-base text-white/90 md:text-lg">You won't find a logo wall or a borrowed case study on this page. Two promises we keep on every brief, and the reach to back them up.</p>
      <div className="mt-16 grid gap-10 lg:grid-cols-12">
        {STATS.map((s, i) => (
          <FadeUp key={s.u} delay={i * 0.08} className={`border-t border-white/40 pt-6 ${s.cls}`} data-testid={`stat-${s.u}`}>
            <p className="font-display flex items-start font-bold leading-none tracking-[-0.05em]">
              <span className={s.big ? "text-[9rem] sm:text-[13rem]" : "text-8xl sm:text-9xl"}>{s.n}</span>
              <span className="font-mono-x ml-2 mt-3 text-sm tracking-normal text-[#D4FF3D]">{s.u}</span>
            </p>
            <p className="mt-4 max-w-xs text-white/90">{s.t}</p>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
